/**
 * Этот файл - главная точка подключения всех своих и сторонних js библиотек и стилей.
 * В статическом src-public/index.html размещен базовый HTML шаблон, в котором подключается приложение.
 * Здесь не описывается поведение компонентов, а происходит только их загрузка.
 * Поведение главного компонента размещено в components/App.vue - начиная с него стартует вся логика.
 */
import Vue from "vue";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueHotkey from "v-hotkey";
import VueKonva from "vue-konva";
import {default as Vuedals} from "vuedals";

import "./lib/filters.js";
import "./lib/directives.js";
import "./lib/globals.js";
import SpinnerLoading from "./components/spinnerLoading/SpinnerLoading.vue";
import SpinnerLoadingModal from "./components/spinnerLoading/SpinnerLoadingModal.vue";
import SmartInputText from "./components/smartInputs/SmartInputText.vue";
import SmartInputArray from "./components/smartInputs/SmartInputArray.vue";
import SmartInputDate from "./components/smartInputs/SmartInputDate.vue";
import SmartInputImage from "./components/smartInputs/SmartInputImage.vue";
import SmartSelect from "./components/smartInputs/SmartSelect.vue";
import SmartVSelect from "./components/smartInputs/SmartVSelect.vue";
import SmartSwitch from "./components/smartInputs/SmartSwitch.vue";
import CamsButton from "./components/button/CamsButton.vue";
import camsdals from "./components/dialogs/camsdals.js";

import "./components/table/style.scss";
import "./styles/style.scss";

// Компонент создания модальных окон.
Vue.use(Vuedals);
// Собственный компонент создания модальных окон (прослойка для Vuedals).
Vue.use(camsdals);
// Компонент выбора даты и времени.
Vue.use(flatPickr);
// Плагин для горячих клавиш.
Vue.use(VueHotkey);
// Плагин для рисования на canvas.
Vue.use(VueKonva);
// Анимация загрузки.
Vue.component("SpinnerLoading", SpinnerLoading);
Vue.component("SpinnerLoadingModal", SpinnerLoadingModal);
// Поля ввода в формы.
Vue.component("SmartInputText", SmartInputText);
Vue.component("SmartInputArray", SmartInputArray);
Vue.component("SmartInputDate", SmartInputDate);
Vue.component("SmartInputImage", SmartInputImage);
Vue.component("SmartSelect", SmartSelect);
Vue.component("SmartVSelect", SmartVSelect);
Vue.component("SmartSwitch", SmartSwitch);
// Кнопки.
Vue.component("CamsButton", CamsButton);

moment.locale("ru");
import VueI18n from 'vue-i18n';
import {enMessages} from "./i18n/en.js";
import {ruMessages} from "./i18n/ru.js";
import {trMessages} from "./i18n/tr.js";
// Подключаем VueI18n
Vue.use(VueI18n);
// Настраиваем i18n
const messages = {
  en: enMessages,
  ru: ruMessages,
  tr: trMessages,
};
export const i18n = new VueI18n({
  locale: 'ru', // Язык по умолчанию
  messages,
});
